import { render, staticRenderFns } from "./GroupDashboardAgents.vue?vue&type=template&id=e8ecce70&"
import script from "./GroupDashboardAgents.vue?vue&type=script&lang=js&"
export * from "./GroupDashboardAgents.vue?vue&type=script&lang=js&"
import style0 from "./GroupDashboardAgents.vue?vue&type=style&index=0&id=e8ecce70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports